import { useFormContext, useWatch } from "react-hook-form";
import { UpdateProfileFormValues } from "../../useUpdateProfileForm";
import { useTranslation } from "react-i18next";
import { useAmenities } from "./useAmenities";
import { Combobox } from "@ttc3k/trekker";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";

export const Amenities = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<UpdateProfileFormValues>();
  const amenities = useWatch({
    control: control,
    name: "amenities",
  });
  const {
    tagsLoading,
    tagsError,
    filterableAmenityTags,
    onTagInputValueSearch,
    onComboboxOpenChange,
  } = useAmenities();

  const handleSelectAmenities = (amenities: string[]) => {
    setValue("amenities", amenities, { shouldDirty: true });
  };

  return (
    <>
      {filterableAmenityTags.length > 0 && !tagsLoading ? (
        <Combobox.Root
          value={amenities}
          items={filterableAmenityTags.map((tagGroup) => tagGroup.tags).flat()}
          multiple
          onOpenChange={onComboboxOpenChange}
          onValueChange={(d) => handleSelectAmenities(d.value)}
          onInputValueChange={(d) => onTagInputValueSearch(d.inputValue)}
          placeholder={`${t("directory:OPERATOR.BACK_OFFICE.TAGS.PLACEHOLDER_LABEL")}...`}
          tagVisualVariant={"accent.blue"}
        >
          {filterableAmenityTags.map((item) => (
            <Combobox.ItemGroup key={item.group}>
              <Combobox.ItemGroupLabel>
                {t(`core:LOOKUPS.AMENITY_TAG_GROUP_KEY.${item.group}`)}
              </Combobox.ItemGroupLabel>
              {item.tags.map((tag) => (
                <Combobox.Item
                  paddingLeft={"300"}
                  key={tag.value}
                  item={tag}
                  {...tag}
                />
              ))}
            </Combobox.ItemGroup>
          ))}
        </Combobox.Root>
      ) : (
        <>{tagsError ? <SimpleErrorNotification /> : <SimpleLoader />}</>
      )}
    </>
  );
};
